<template>
  <div class="container-dba">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- banner  -->
    <div class="banner-info"></div>
    <!-- 中间内容部分 -->
    <div class="edu-wrapper">
      <div class="meun">
        <div class="meun-right">
          <p class="right-title">企业招聘</p>
          <table class="gangwei-table">
            <tr>
              <!--              <td class="weight">序号</td>-->
              <td class="weight">归属公司</td>
              <!--              <td class="weight">团队名称</td>-->
              <td class="weight">岗位名称</td>
              <td class="weight">岗位类别</td>
              <td class="weight">数量</td>
            </tr>
            <tr v-for="item of dataList">
              <!--              <td>{{ item.contentA }}</td>-->
              <td>{{ item.contentB }}</td>
              <!--              <td>{{ item.contentC }}</td>-->
              <td>{{ item.contentD }}</td>
              <td>{{ item.contentE }}</td>
              <td>{{ item.contentF }}</td>
            </tr>
          </table>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "EduData",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      dataList: [
        {
          number: "1",
          contentA: "中国东信",
          contentB: "集团管理层",
          contentC: "CTO",
          contentD: "集团管理层",
          contentE: "管理类",
          contentF: "1",
        },
        {
          number: "2",
          contentA: "中国东信",
          contentB: "集团管理层",
          contentC: "执行总裁",
          contentD: "集团管理层",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "3",
          contentA: "东信互联",
          contentB: "互联运维团队",
          contentC: "运维总监",
          contentD: "总监",
          contentE: "研发类",
          contentF: "1"
        },
        {
          number: "4",
          contentA: "航交所",
          contentB: "航交所业务团队",
          contentC: "航运业务总监",
          contentD: "总监",
          contentE: "销售类",
          contentF: "1"
        },
        {
          number: "5",
          contentA: "数交所",
          contentB: "数交所管理层",
          contentC: "数交所总经理",
          contentD: "总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "6",
          contentA: "东信网联",
          contentB: "东信网联管理层",
          contentC: "东信网联副总经理",
          contentD: "副总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "7",
          contentA: "东信创联",
          contentB: "东信创联管理层",
          contentC: "副总经理",
          contentD: "副总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "8",
          contentA: "东信网安",
          contentB: "管理层",
          contentC: "副总经理",
          contentD: "副总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "9",
          contentA: "山东公司",
          contentB: "管理层",
          contentC: "总经理",
          contentD: "副总经理/总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "10",
          contentA: "华建通（新疆公司）",
          contentB: "管理层",
          contentC: "总经理",
          contentD: "副总经理/总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "11",
          contentA: "棉联网",
          contentB: "管理层",
          contentC: "总经理",
          contentD: "副总经理/总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "12",
          contentA: "盐联网",
          contentB: "管理层",
          contentC: "总经理",
          contentD: "副总经理/总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "13",
          contentA: "东信云网",
          contentB: "管理层",
          contentC: "产品副总或产品总监",
          contentD: "总监",
          contentE: "产品类",
          contentF: "1"
        },
        {
          number: "14",
          contentA: "东信云网",
          contentB: "管理层",
          contentC: "运营总监",
          contentD: "总监",
          contentE: "运营类",
          contentF: "1"
        },
        {
          number: "15",
          contentA: "东信数建",
          contentB: "管理层",
          contentC: "副总经理",
          contentD: "副总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "16",
          contentA: "中国东信",
          contentB: "信创事业群管理层",
          contentC: "销售副总经理/总监",
          contentD: "副总经理/总监",
          contentE: "销售类",
          contentF: "1"
        },
        {
          number: "17",
          contentA: "东信易通",
          contentB: "东信易通管理层",
          contentC: "CTO",
          contentD: "副总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "18",
          contentA: "东信数科",
          contentB: "产品创新中心",
          contentC: "产品总监",
          contentD: "总监",
          contentE: "产品类",
          contentF: "1"
        },
        {
          number: "19",
          contentA: "东信数科",
          contentB: "产品创新中心",
          contentC: "研发总监",
          contentD: "总监",
          contentE: "研发类",
          contentF: "1"
        },
        {
          number: "20",
          contentA: "东信数链",
          contentB: "东信数链管理层",
          contentC: "商务总监",
          contentD: "总监",
          contentE: "销售类",
          contentF: "1"
        },
        {
          number: "21",
          contentA: "东信国际",
          contentB: "东信国际南宁团队",
          contentC: "副总经理",
          contentD: "副总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "22",
          contentA: "玉林公司",
          contentB: "玉林公司",
          contentC: "总经理",
          contentD: "总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "23",
          contentA: "中国东信",
          contentB: "技术研究中心",
          contentC: "技术研究中心主任",
          contentD: "总监",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "24",
          contentA: "产品研究中心",
          contentB: "产品研究中心主任",
          contentC: "执行总裁",
          contentD: "总监",
          contentE: "职能类",
          contentF: "1"
        },
        {
          number: "25",
          contentA: "中国东信",
          contentB: "管理团队",
          contentC: "副总经理（数字中台）",
          contentD: "副总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "26",
          contentA: "中国东信",
          contentB: "管理团队",
          contentC: "副总经理（交付方向）",
          contentD: "副总经理",
          contentE: "管理类",
          contentF: "1"
        },
        {
          number: "27",
          contentA: "中国东信",
          contentB: "交付团队",
          contentC: "研发总监（交付方向）",
          contentD: "总监",
          contentE: "研发类",
          contentF: "3"
        },
        {
          number: "28",
          contentA: "中国东信",
          contentB: "中间件团队",
          contentC: "研发总监（大数据及AI",
          contentD: "总监",
          contentE: "研发类",
          contentF: "1"
        },
        {
          number: "29",
          contentA: "中国东信",
          contentB: "北京总部",
          contentC: "政府关系总监",
          contentD: "总监",
          contentE: "销售类",
          contentF: "3"
        },

      ]
    };
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
/* .banner-info */

.banner-info {
  width: 100%;
  height: 200px;
  background: url(../../assets/images/banner002.png);
  background-size: 100% 100%;
}

.edu-wrapper {
  width: 95%;
  margin: 0 auto;
  margin-bottom: 50px;
}

.right-title {
  background: url(../../assets/images/pic1.png) no-repeat;
  background-size: 100% 100%;
  width: 212px;
  height: 69px;
  text-align: center;
  line-height: 56px;
  font-size: 32px;
  padding-left: 40px;
  margin-top: 25px;
  margin-bottom: 17px;
}

.meun-right img {
  width: 100%;
  margin: 20px 0;
}

.content-p {
  font-size: 32px;
  margin-top: 20px;
}

h3 {
  font-size: 32px;
  margin-top: 20px;
}

h1 {
  font-size: 34px;
  margin-top: 20px;
}
/*岗位table*/
.gangwei-table {
  width: 100%;
  margin-top: 20px;
  border: none;
  border-radius: 5px;
}
.gangwei-table tr td {
  padding: 3px 5px;
  text-align: center;
  border-bottom: 1px solid rgba(231, 138, 47, 1);
  font-size: 30px;
  height: 80px;
}

</style>



// WEBPACK FOOTER //
// src/pages/admissions/recruitmentPage.vue